import * as TP from '../subscriptionTypes';

import { gql } from '@apollo/client';
import { RouteLockingEventPayloadFragmentDoc } from '../subscriptionFragments/routeLockingEvent';
import { LinkedRouteEventPayloadFragmentDoc } from '../subscriptionFragments/linkedRouteEvent';
import { LoadStatusEventPayloadFragmentDoc } from '../subscriptionFragments/loadStatusEvent';
import { RouteStatusEventPayloadFragmentDoc } from '../subscriptionFragments/routeStatusEvent';
import { BaseEventPayloadFragmentDoc } from '../subscriptionFragments/baseEvent';
import { TrackingStatusEventPayloadFragmentDoc } from '../subscriptionFragments/trackingStatusEvent';
import { DriverAssignmentEventPayloadFragmentDoc } from '../subscriptionFragments/driverAssignmentEventPayload';
import { BookingEventPayloadFragmentDoc } from '../subscriptionFragments/bookingEvent';
import { BookingOrchestrationStatusEventPayloadFragmentDoc } from '../subscriptionFragments/bookingOrchestrationStatusEvent';
import { RouteVendorEventPayloadFragmentDoc } from '../subscriptionFragments/routeVendorEvent';
import { CarrierMatchEventPayloadFragmentDoc } from '../subscriptionFragments/carrierMatchEvent';
import { TruckPostingMatchEventPayloadFragmentDoc } from '../subscriptionFragments/truckMatchEvent';
import { ProcurementMatchActionTakenEventPayloadFragmentDoc } from '../subscriptionFragments/matchActionTakenEventPayload';
import { SubStopExecutionEventPayloadFragmentDoc } from '../subscriptionFragments/subStopExecutionEventPayload';
import { CommissionsRecalculatedEventPayloadFragmentDoc } from '../subscriptionFragments/commissionsRecalculatedEvent';
import { TenderPlanEventPayloadFragmentDoc } from '../subscriptionFragments/tenderPlanEvent';
import { TenderPlanRouteEventPayloadFragmentDoc } from '../subscriptionFragments/tenderPlanRouteEvent';
import { TrackingUpdateEventPayloadFragmentDoc } from '../subscriptionFragments/trackingUpdateEvent';
import { ToastEventPayloadFragmentDoc } from '../subscriptionFragments/toastEvent';
import { OfferStatusEventPayloadFragmentDoc } from '../subscriptionFragments/offerStatusEvent';
import { OfferEventPayloadFragmentDoc } from '../subscriptionFragments/offerEvent';
import { RouteMaxCostEventPayloadFragmentDoc } from '../subscriptionFragments/routeMaxCostEvent';
import { PricingRateEventPayloadFragmentDoc } from '../subscriptionFragments/pricingRateEvent';
import { CostLineItemEventPayloadFragmentDoc } from '../subscriptionFragments/costLineItemEvent';
import { RateLineItemEventPayloadFragmentDoc } from '../subscriptionFragments/rateLineItemEvent';
import { ClientExceptionRecordEventPayloadFragmentDoc } from '../subscriptionFragments/clientExceptionRecordEvent';
import { IncidentEventPayloadFragmentDoc } from '../subscriptionFragments/incidentsEvent';
import { MinionRefreshEventPayloadFragmentDoc } from '../subscriptionFragments/minionRefreshEvent';
import { MessagingNotificationStatusEventPayloadFragmentDoc } from '../subscriptionFragments/messagingNotificationStatusEvent';
import { PatternOrderApplicationStatusEventPayloadFragmentDoc } from '../subscriptionFragments/patternOrderApplicationStatusEvent';
import { PatternOrderMatchEventPayloadFragmentDoc } from '../subscriptionFragments/patternOrderMatchEvent';
import { RepeatLoadEventPayloadFragmentDoc } from '../subscriptionFragments/repeatLoadEvent';
import { PostingChangeEventPayloadFragmentDoc } from '../subscriptionFragments/postingChangeEvent';
import { RateConfirmationChangeEventPayloadFragmentDoc } from '../subscriptionFragments/rateConfirmationChangeEvent';
import { AvailableCapacityEventPayloadFragmentDoc } from '../subscriptionFragments/availableCapacityEvent';
import { EdiTransactionStorageEventPayloadFragmentDoc } from '../subscriptionFragments/ediTransactionStorageEventPayload';
import { DocumentGenerateEventPayloadFragmentDoc } from '../subscriptionFragments/documentGenerateEvent';
import { BookingFailureEventPayloadFragmentDoc } from '../subscriptionFragments/bookingFailureEvent';
import { DriverMessagingNewMessageEventPayloadFragmentDoc } from '../subscriptionFragments/driverMessagingNewMessageEvent';
import { DriverMessagingNewMessageEventV2PayloadFragmentDoc } from '../subscriptionFragments/driverMessagingNewMessageEventV2';
import { DriverMessagingEventV3PayloadFragmentDoc } from '../subscriptionFragments/driverMessagingEventV3';
import { LoadEmrEventPayloadFragmentDoc } from '../subscriptionFragments/loadEMRMessageEvent';
import { DriverPreplanEventPayloadFragmentDoc } from '../subscriptionFragments/driverPreplanEventPayload';
import { AssetDriverCurrentHosEventPayloadFragmentDoc } from '../subscriptionFragments/assetDriverCurrentHosEvent';
import { RecalculateMileageEventPayloadFragmentDoc } from '../subscriptionFragments/recalculateMileageEvent';
import { OrderFinancialStatusEventPayloadFragmentDoc } from '../subscriptionFragments/orderFinancialStatusEvent';
import { RouteVendorFinancialStatusEventPayloadFragmentDoc } from '../subscriptionFragments/routeVendorFinancialStatusEvent';
import { OptimizationExecutionStatusEventPayloadFragmentDoc } from '../subscriptionFragments/optimizationExecutionStatusEvent';
import { MassUpdateEventPayloadFragmentDoc } from '../subscriptionFragments/massUpdateEvent';
import { StopEventAuditStatusEventPayloadFragmentDoc } from '../subscriptionFragments/stopEventAuditStatusEvent';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type SubscribeSubscriptionVariables = TP.Exact<{
  eventTypes?: TP.InputMaybe<ReadonlyArray<TP.EventType> | TP.EventType>;
  ids?: TP.InputMaybe<ReadonlyArray<TP.Scalars['String']> | TP.Scalars['String']>;
}>;


export type SubscribeSubscription = (
  { readonly __typename?: 'Subscription' }
  & { readonly subscribe: (
    { readonly __typename: 'BaseEvent' }
    & Pick<TP.BaseEvent, 'id' | 'type'>
  ) | (
    { readonly __typename: 'RouteLockingEvent' }
    & Pick<TP.RouteLockingEvent, 'id' | 'type' | 'expirationTimestamp' | 'userIdentity' | 'adminIdentity' | 'lockEventType'>
  ) | (
    { readonly __typename: 'LinkedRouteEvent' }
    & Pick<TP.LinkedRouteEvent, 'id' | 'type'>
  ) | (
    { readonly __typename: 'LoadStatusEvent' }
    & Pick<TP.LoadStatusEvent, 'id' | 'type'>
  ) | (
    { readonly __typename: 'RouteStatusEvent' }
    & Pick<TP.RouteStatusEvent, 'id' | 'type' | 'capacityNeed' | 'routeLifecycleStatus' | 'routeActivationStatus'>
  ) | { readonly __typename: 'TaskEvent' } | { readonly __typename: 'TasksByLoadIdEvent' } | (
    { readonly __typename: 'TrackingStatusEvent' }
    & Pick<TP.TrackingStatusEvent, 'id' | 'trackingStatus'>
  ) | (
    { readonly __typename: 'DriverAssignmentEvent' }
    & Pick<TP.DriverAssignmentEvent, 'id' | 'driverAssignmentID' | 'eventTimestamp'>
  ) | (
    { readonly __typename: 'SubStopExecutionEvent' }
    & Pick<TP.SubStopExecutionEvent, 'id' | 'stopEventIDs' | 'stopEventTypeID' | 'stopID' | 'actionType'>
  ) | (
    { readonly __typename: 'TruckPostingMatchEvent' }
    & Pick<TP.TruckPostingMatchEvent, 'id' | 'type'>
  ) | (
    { readonly __typename: 'CarrierMatchEvent' }
    & Pick<TP.CarrierMatchEvent, 'id' | 'type'>
  ) | { readonly __typename: 'UserMatchEvent' } | { readonly __typename: 'RouteMatchEvent' } | (
    { readonly __typename: 'RouteVendorEvent' }
    & Pick<TP.RouteVendorEvent, 'id' | 'loadId' | 'routeId' | 'type'>
  ) | (
    { readonly __typename: 'BookingEvent' }
    & Pick<TP.BookingEvent, 'id' | 'type' | 'routeVendorId' | 'capacityId' | 'bookingSourceId'>
  ) | (
    { readonly __typename: 'BookingFailureEvent' }
    & Pick<TP.BookingFailureEvent, 'id' | 'type'>
    & { readonly bookingErrors?: TP.Maybe<ReadonlyArray<(
      { readonly __typename?: 'BookingError' }
      & Pick<TP.BookingError, 'code' | 'message'>
    )>> }
  ) | (
    { readonly __typename: 'CommissionsRecalculatedEvent' }
    & Pick<TP.CommissionsRecalculatedEvent, 'id' | 'loadId' | 'type'>
  ) | (
    { readonly __typename: 'TenderPlanEvent' }
    & Pick<TP.TenderPlanEvent, 'id' | 'type'>
  ) | (
    { readonly __typename: 'TenderPlanRouteEvent' }
    & Pick<TP.TenderPlanRouteEvent, 'id' | 'type'>
  ) | (
    { readonly __typename: 'TrackingUpdateEvent' }
    & Pick<TP.TrackingUpdateEvent, 'id' | 'trackingUpdateId' | 'trackingUpdateEventType' | 'type'>
  ) | (
    { readonly __typename: 'ToastEvent' }
    & Pick<TP.ToastEvent, 'id' | 'toastType' | 'message'>
  ) | (
    { readonly __typename: 'OfferEvent' }
    & Pick<TP.OfferEvent, 'id' | 'type' | 'offerId' | 'carrierId'>
  ) | (
    { readonly __typename: 'OfferStatusEvent' }
    & Pick<TP.OfferStatusEvent, 'id' | 'type' | 'routeId' | 'carrierId' | 'offerStatus' | 'offerType'>
  ) | (
    { readonly __typename: 'RouteMaxCostEvent' }
    & Pick<TP.RouteMaxCostEvent, 'id' | 'routeMaxCost' | 'type'>
  ) | (
    { readonly __typename: 'CostLineItemEvent' }
    & Pick<TP.CostLineItemEvent, 'id' | 'action' | 'costLineItemId'>
  ) | (
    { readonly __typename: 'RateLineItemEvent' }
    & Pick<TP.RateLineItemEvent, 'id' | 'action' | 'rateLineItemId'>
  ) | (
    { readonly __typename: 'OrderFinancialStatusEvent' }
    & Pick<TP.OrderFinancialStatusEvent, 'id' | 'financialStatus' | 'type'>
  ) | (
    { readonly __typename: 'RouteVendorFinancialStatusEvent' }
    & Pick<TP.RouteVendorFinancialStatusEvent, 'id' | 'financialStatus' | 'type'>
    & { vendorIdString: TP.RouteVendorFinancialStatusEvent['vendorId'] }
  ) | (
    { readonly __typename: 'PricingRateEvent' }
    & Pick<TP.PricingRateEvent, 'id' | 'type'>
  ) | (
    { readonly __typename: 'MinionRefreshEvent' }
    & Pick<TP.MinionRefreshEvent, 'id' | 'message' | 'type'>
  ) | (
    { readonly __typename: 'ClientExceptionRecordEvent' }
    & Pick<TP.ClientExceptionRecordEvent, 'id' | 'clientExceptionRecordId' | 'clientExceptionRecordEventType' | 'type'>
  ) | { readonly __typename: 'ClientExceptionRecordFilteredEvent' } | (
    { readonly __typename: 'IncidentEvent' }
    & Pick<TP.IncidentEvent, 'id' | 'incidentID' | 'incidentEventType' | 'type'>
  ) | (
    { readonly __typename: 'MessagingNotificationStatusEvent' }
    & Pick<TP.MessagingNotificationStatusEvent, 'id' | 'type' | 'status' | 'serverType' | 'errorMessage'>
  ) | (
    { readonly __typename: 'PatternOrderApplicationStatusEvent' }
    & Pick<TP.PatternOrderApplicationStatusEvent, 'id' | 'type'>
  ) | (
    { readonly __typename: 'ProcurementMatchActionTakenEvent' }
    & Pick<TP.ProcurementMatchActionTakenEvent, 'id' | 'actionsTaken' | 'type'>
  ) | (
    { readonly __typename: 'RepeatLoadEvent' }
    & Pick<TP.RepeatLoadEvent, 'id' | 'type' | 'rowUniqueId' | 'orderCode' | 'orderStatus' | 'message' | 'activationStatus' | 'activationStatusReason'>
    & { repeatedLoadId: TP.RepeatLoadEvent['loadId'] }
    & { readonly routes?: TP.Maybe<ReadonlyArray<(
      { readonly __typename?: 'RepeatedRoute' }
      & Pick<TP.RepeatedRoute, 'id' | 'code' | 'sequence'>
    )>> }
  ) | (
    { readonly __typename: 'PostingChangeEvent' }
    & Pick<TP.PostingChangeEvent, 'id' | 'type' | 'loadId' | 'routeId'>
  ) | (
    { readonly __typename: 'DocumentGenerateEvent' }
    & Pick<TP.DocumentGenerateEvent, 'id' | 'documentStatusType' | 'documentStatusMessage' | 'documentGenerationRequestId' | 'userInfo' | 'documentType' | 'type'>
  ) | (
    { readonly __typename: 'RateConfirmationChangeEvent' }
    & Pick<TP.RateConfirmationChangeEvent, 'id' | 'type' | 'success'>
    & { routeVendorIdString: TP.RateConfirmationChangeEvent['routeVendorId'], rateConRouteId: TP.RateConfirmationChangeEvent['routeId'] }
  ) | { readonly __typename: 'CapacityUtilizationStatusEvent' } | (
    { readonly __typename: 'EdiTransactionStorageEvent' }
    & Pick<TP.EdiTransactionStorageEvent, 'id' | 'type' | 'ediTransactionId'>
  ) | (
    { readonly __typename: 'AvailableCapacityEvent' }
    & Pick<TP.AvailableCapacityEvent, 'id' | 'type' | 'capacityType' | 'utilizationStatus'>
  ) | (
    { readonly __typename: 'PreplanEvent' }
    & Pick<TP.PreplanEvent, 'id' | 'routeId'>
  ) | (
    { readonly __typename: 'PatternOrderMatchEvent' }
    & Pick<TP.PatternOrderMatchEvent, 'id' | 'patternCount'>
  ) | (
    { readonly __typename: 'DriverMessagingNewMessageEvent' }
    & Pick<TP.DriverMessagingNewMessageEvent, 'id' | 'conversationId' | 'sentByUserId'>
  ) | (
    { readonly __typename: 'DriverMessagingNewMessageEventV2' }
    & Pick<TP.DriverMessagingNewMessageEventV2, 'id' | 'drivers'>
    & { readonly conversation: (
      { readonly __typename?: 'Conversation' }
      & Pick<TP.Conversation, 'classification' | 'value'>
    ) }
  ) | (
    { readonly __typename: 'DriverMessagingEventV3' }
    & Pick<TP.DriverMessagingEventV3, 'id' | 'drivers' | 'assignmentId' | 'followUpTimeId' | 'errors'>
    & { messageNullable: TP.DriverMessagingEventV3['message'] }
    & { readonly conversation: (
      { readonly __typename?: 'Conversation' }
      & Pick<TP.Conversation, 'classification' | 'value'>
    ) }
  ) | { readonly __typename: 'DriverMessagingAssignmentUpdatedSuccessEvent' } | { readonly __typename: 'DriverMessagingAssignmentUpdatedFailureEvent' } | (
    { readonly __typename: 'LoadEMREvent' }
    & Pick<TP.LoadEmrEvent, 'id' | 'driverId'>
    & { loadEmrRouteId: TP.LoadEmrEvent['routeId'] }
    & { readonly loadEmrMessage: (
      { readonly __typename?: 'LoadEMRMessage' }
      & Pick<TP.LoadEmrMessage, 'type' | 'message'>
    ) }
  ) | (
    { readonly __typename: 'AssetDriverCurrentHosEvent' }
    & Pick<TP.AssetDriverCurrentHosEvent, 'id' | 'driverId'>
    & { readonly computedCurrentHosClocks?: TP.Maybe<(
      { readonly __typename?: 'ComputedCurrentHosClocks' }
      & Pick<TP.ComputedCurrentHosClocks, 'id'>
      & { readonly driverTime?: TP.Maybe<(
        { readonly __typename?: 'DriverHosTime' }
        & Pick<TP.DriverHosTime, 'remaining' | 'utilized'>
      )>, readonly shiftTime?: TP.Maybe<(
        { readonly __typename?: 'DriverHosTime' }
        & Pick<TP.DriverHosTime, 'remaining' | 'utilized'>
      )>, readonly breakTime?: TP.Maybe<(
        { readonly __typename?: 'DriverHosTime' }
        & Pick<TP.DriverHosTime, 'remaining' | 'utilized'>
      )>, readonly cycleTime?: TP.Maybe<(
        { readonly __typename?: 'DriverHosTime' }
        & Pick<TP.DriverHosTime, 'remaining' | 'utilized'>
      )> }
    )> }
  ) | (
    { readonly __typename: 'BookingOrchestrationStatusEvent' }
    & Pick<TP.BookingOrchestrationStatusEvent, 'id' | 'capacityId' | 'bookingSourceId' | 'vendorId'>
    & { bookingRouteVendorId: TP.BookingOrchestrationStatusEvent['routeVendorId'], bookingDriverId: TP.BookingOrchestrationStatusEvent['driverId'] }
    & { readonly bookingProgress?: TP.Maybe<ReadonlyArray<(
      { readonly __typename?: 'BookingProgress' }
      & Pick<TP.BookingProgress, 'step' | 'status' | 'info'>
      & { readonly errors?: TP.Maybe<ReadonlyArray<(
        { readonly __typename?: 'BookingError' }
        & Pick<TP.BookingError, 'code' | 'message'>
      )>> }
    )>> }
  ) | { readonly __typename: 'LoadTenderOrchestrationEvent' } | (
    { readonly __typename: 'RecalculateMileageEvent' }
    & Pick<TP.RecalculateMileageEvent, 'id' | 'orderId' | 'correlationId' | 'mileageType'>
    & { loadIdentifier: TP.RecalculateMileageEvent['loadId'], routeIdentifier: TP.RecalculateMileageEvent['routeId'] }
  ) | { readonly __typename: 'ProjectedAccumulatedDriverPayEvent' } | (
    { readonly __typename: 'OptimizationExecutionStatusEvent' }
    & Pick<TP.OptimizationExecutionStatusEvent, 'id' | 'type'>
    & { solutionProgress: TP.OptimizationExecutionStatusEvent['status'] }
  ) | (
    { readonly __typename: 'MassUpdateEvent' }
    & Pick<TP.MassUpdateEvent, 'id' | 'updateType' | 'outcome' | 'source'>
    & { massUpdateRouteId: TP.MassUpdateEvent['routeId'], massUpdateCorrelationId: TP.MassUpdateEvent['correlationId'], massUpdateErrorMessage: TP.MassUpdateEvent['errorMessage'], massUpdateWarningMessage: TP.MassUpdateEvent['warningMessage'] }
  ) | (
    { readonly __typename: 'StopEventAuditStatusEvent' }
    & Pick<TP.StopEventAuditStatusEvent, 'id' | 'stopID' | 'eventStatus' | 'auditType' | 'message'>
  ) | { readonly __typename: 'PatternOrderApplicationStepEvent' } }
);


export const SubscribeDocument = gql`
    subscription Subscribe($eventTypes: [EventType!], $ids: [String!]) {
  subscribe(ids: $ids, types: $eventTypes) {
    __typename
    ... on RouteLockingEvent {
      ...RouteLockingEventPayload
    }
    ... on LinkedRouteEvent {
      ...LinkedRouteEventPayload
    }
    ... on LoadStatusEvent {
      ...LoadStatusEventPayload
    }
    ... on RouteStatusEvent {
      ...RouteStatusEventPayload
    }
    ... on BaseEvent {
      ...BaseEventPayload
    }
    ... on TrackingStatusEvent {
      ...TrackingStatusEventPayload
    }
    ... on DriverAssignmentEvent {
      ...DriverAssignmentEventPayload
    }
    ... on BookingEvent {
      ...BookingEventPayload
    }
    ... on BookingOrchestrationStatusEvent {
      ...BookingOrchestrationStatusEventPayload
    }
    ... on RouteVendorEvent {
      ...RouteVendorEventPayload
    }
    ... on CarrierMatchEvent {
      ...CarrierMatchEventPayload
    }
    ... on TruckPostingMatchEvent {
      ...TruckPostingMatchEventPayload
    }
    ... on ProcurementMatchActionTakenEvent {
      ...ProcurementMatchActionTakenEventPayload
    }
    ... on SubStopExecutionEvent {
      ...SubStopExecutionEventPayload
    }
    ... on CommissionsRecalculatedEvent {
      ...CommissionsRecalculatedEventPayload
    }
    ... on TenderPlanEvent {
      ...TenderPlanEventPayload
    }
    ... on TenderPlanRouteEvent {
      ...TenderPlanRouteEventPayload
    }
    ... on TrackingUpdateEvent {
      ...TrackingUpdateEventPayload
    }
    ... on ToastEvent {
      ...ToastEventPayload
    }
    ... on OfferStatusEvent {
      ...OfferStatusEventPayload
    }
    ... on OfferEvent {
      ...OfferEventPayload
    }
    ... on RouteMaxCostEvent {
      ...RouteMaxCostEventPayload
    }
    ... on PricingRateEvent {
      ...PricingRateEventPayload
    }
    ... on CostLineItemEvent {
      ...CostLineItemEventPayload
    }
    ... on RateLineItemEvent {
      ...RateLineItemEventPayload
    }
    ... on ClientExceptionRecordEvent {
      ...ClientExceptionRecordEventPayload
    }
    ... on IncidentEvent {
      ...IncidentEventPayload
    }
    ... on MinionRefreshEvent {
      ...MinionRefreshEventPayload
    }
    ... on MessagingNotificationStatusEvent {
      ...MessagingNotificationStatusEventPayload
    }
    ... on PatternOrderApplicationStatusEvent {
      ...PatternOrderApplicationStatusEventPayload
    }
    ... on PatternOrderMatchEvent {
      ...PatternOrderMatchEventPayload
    }
    ... on RepeatLoadEvent {
      ...RepeatLoadEventPayload
    }
    ... on PostingChangeEvent {
      ...PostingChangeEventPayload
    }
    ... on RateConfirmationChangeEvent {
      ...RateConfirmationChangeEventPayload
    }
    ... on AvailableCapacityEvent {
      ...AvailableCapacityEventPayload
    }
    ... on EdiTransactionStorageEvent {
      ...EdiTransactionStorageEventPayload
    }
    ... on DocumentGenerateEvent {
      ...DocumentGenerateEventPayload
    }
    ... on BookingFailureEvent {
      ...BookingFailureEventPayload
    }
    ... on DriverMessagingNewMessageEvent {
      ...DriverMessagingNewMessageEventPayload
    }
    ... on DriverMessagingNewMessageEventV2 {
      ...DriverMessagingNewMessageEventV2Payload
    }
    ... on DriverMessagingEventV3 {
      ...DriverMessagingEventV3Payload
    }
    ... on LoadEMREvent {
      ...LoadEMREventPayload
    }
    ... on PreplanEvent {
      ...DriverPreplanEventPayload
    }
    ... on AssetDriverCurrentHosEvent {
      ...AssetDriverCurrentHosEventPayload
    }
    ... on RecalculateMileageEvent {
      ...RecalculateMileageEventPayload
    }
    ... on OrderFinancialStatusEvent {
      ...OrderFinancialStatusEventPayload
    }
    ... on RouteVendorFinancialStatusEvent {
      ...RouteVendorFinancialStatusEventPayload
    }
    ... on OptimizationExecutionStatusEvent {
      ...OptimizationExecutionStatusEventPayload
    }
    ... on MassUpdateEvent {
      ...MassUpdateEventPayload
    }
    ... on StopEventAuditStatusEvent {
      ...StopEventAuditStatusEventPayload
    }
  }
}
    ${RouteLockingEventPayloadFragmentDoc}
${LinkedRouteEventPayloadFragmentDoc}
${LoadStatusEventPayloadFragmentDoc}
${RouteStatusEventPayloadFragmentDoc}
${BaseEventPayloadFragmentDoc}
${TrackingStatusEventPayloadFragmentDoc}
${DriverAssignmentEventPayloadFragmentDoc}
${BookingEventPayloadFragmentDoc}
${BookingOrchestrationStatusEventPayloadFragmentDoc}
${RouteVendorEventPayloadFragmentDoc}
${CarrierMatchEventPayloadFragmentDoc}
${TruckPostingMatchEventPayloadFragmentDoc}
${ProcurementMatchActionTakenEventPayloadFragmentDoc}
${SubStopExecutionEventPayloadFragmentDoc}
${CommissionsRecalculatedEventPayloadFragmentDoc}
${TenderPlanEventPayloadFragmentDoc}
${TenderPlanRouteEventPayloadFragmentDoc}
${TrackingUpdateEventPayloadFragmentDoc}
${ToastEventPayloadFragmentDoc}
${OfferStatusEventPayloadFragmentDoc}
${OfferEventPayloadFragmentDoc}
${RouteMaxCostEventPayloadFragmentDoc}
${PricingRateEventPayloadFragmentDoc}
${CostLineItemEventPayloadFragmentDoc}
${RateLineItemEventPayloadFragmentDoc}
${ClientExceptionRecordEventPayloadFragmentDoc}
${IncidentEventPayloadFragmentDoc}
${MinionRefreshEventPayloadFragmentDoc}
${MessagingNotificationStatusEventPayloadFragmentDoc}
${PatternOrderApplicationStatusEventPayloadFragmentDoc}
${PatternOrderMatchEventPayloadFragmentDoc}
${RepeatLoadEventPayloadFragmentDoc}
${PostingChangeEventPayloadFragmentDoc}
${RateConfirmationChangeEventPayloadFragmentDoc}
${AvailableCapacityEventPayloadFragmentDoc}
${EdiTransactionStorageEventPayloadFragmentDoc}
${DocumentGenerateEventPayloadFragmentDoc}
${BookingFailureEventPayloadFragmentDoc}
${DriverMessagingNewMessageEventPayloadFragmentDoc}
${DriverMessagingNewMessageEventV2PayloadFragmentDoc}
${DriverMessagingEventV3PayloadFragmentDoc}
${LoadEmrEventPayloadFragmentDoc}
${DriverPreplanEventPayloadFragmentDoc}
${AssetDriverCurrentHosEventPayloadFragmentDoc}
${RecalculateMileageEventPayloadFragmentDoc}
${OrderFinancialStatusEventPayloadFragmentDoc}
${RouteVendorFinancialStatusEventPayloadFragmentDoc}
${OptimizationExecutionStatusEventPayloadFragmentDoc}
${MassUpdateEventPayloadFragmentDoc}
${StopEventAuditStatusEventPayloadFragmentDoc}`;

/**
 * __useSubscribeSubscription__
 *
 * To run a query within a React component, call `useSubscribeSubscription` and pass it any options that fit your needs.
 * When your component renders, `useSubscribeSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSubscribeSubscription({
 *   variables: {
 *      eventTypes: // value for 'eventTypes'
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useSubscribeSubscription(baseOptions?: Apollo.SubscriptionHookOptions<SubscribeSubscription, SubscribeSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<SubscribeSubscription, SubscribeSubscriptionVariables>(SubscribeDocument, options);
      }
export type SubscribeSubscriptionHookResult = ReturnType<typeof useSubscribeSubscription>;
export type SubscribeSubscriptionResult = Apollo.SubscriptionResult<SubscribeSubscription>;
/** Cypress helper for mocking the Subscribe subscription */
export const mockSubscribe = (
  response: MockResponse<SubscribeSubscription>,
  kwargs?: Cypress.GqlKwargs
): void => cy.gql<SubscribeSubscription>('Subscribe', response as anyOk, kwargs);